import { Topbar } from '@shared/ui/topbar';
import { PreviewSkeleton } from './preview-skeleton';

import styles from './preview.module.css';

/**
 * The route's own `pendingComponent` (`route-catalog.tsx`'s `previewView`),
 * shown while this page's lazy chunk/loader is still in flight -- before
 * `Preview` itself has ever mounted. Without this, that window fell back to
 * `createTenantApp`'s generic `defaultPendingComponent` (`RoutePending`), a
 * template-agnostic gray-box skeleton with no real navbar at all, so the
 * reader saw: generic skeleton bar -> real, correctly-sized navbar the
 * instant `Preview` mounted -- read as the navbar suddenly shrinking. Same
 * fix, same reasoning as `pages/issue/ui/loading.tsx`'s `pendingComponent`
 * (improvements/07.1-per-template-issue-reader-widgets.md): render the real
 * `Topbar` widget immediately (its default `left`/`center` need no page data
 * at all), only the content area stays a generic placeholder -- now
 * `PreviewSkeleton` (shaped like the real cover/TOC, and itself withheld for
 * 300ms so a fast chunk load never flashes it) rather than the old spinner.
 */
export function PreviewRouteLoading() {
	return (
		<div className={styles['container']}>
			<div className={styles['view']}>
				<Topbar className={styles['topbar']} />
				<PreviewSkeleton />
			</div>
		</div>
	);
}
